﻿/*
 * commit id
 * screen message (en_US)
 */

export const ScreenMessageEnUs: { [key: string]: string } = {
  APP_SCN_00001: "Required Item.",
  APP_SCN_00002: "Must be {0} characters or above.",
  APP_SCN_00003: "Must be {0} characters or below.",
  APP_SCN_00004: "Must be from {0} to {1} characters.",
  APP_SCN_00005: "Must be an integer no more than {0} digits.",
  APP_SCN_00006:
    "Must be a number with the integer part being {0} digits or below and the fractional part being {1} digits or below.",
  APP_SCN_00007: "Must be a number {0} or above.",
  APP_SCN_00008: "Must be a number {0} or below.",
  APP_SCN_00009: "Must be a positive number.",
  APP_SCN_00010: "Must be a number 0 or above.",
  APP_SCN_00011: "Must be a negative number.",
  APP_SCN_00012: "Must be a number 0 or below.",
  APP_SCN_00013: "Must be in the format of an email.",
  APP_SCN_00014: "Must be numbers.",
  APP_SCN_00015: "Must be lowercase letters.",
  APP_SCN_00016:
    "Must be lowercase letters or accepted symbols (white space, #, -, ., /, :, @, _).",
  APP_SCN_00017: "Must be uppercase letters.",
  APP_SCN_00018:
    "Must be uppercase letters or accepted symbols (white space, #, -, ., /, :, @, _).",
  APP_SCN_00019: "Must be lowercase or uppercase letters.",
  APP_SCN_00020:
    "Must be lowercase or uppercase letters, or accepted symbols (white space, #, -, ., /, :, @, _).",
  APP_SCN_00021: "Must be numbers, lowercase or uppercase letters.",
  APP_SCN_00022: "Must be numbers or lowercase letters.",
  APP_SCN_00023: "Must be numbers or uppercase letters.",
  APP_SCN_00024:
    "Must be numbers, lowercase or uppercase letters, or accepted symbols (white space, #, -, ., /, :, @, _).",
  APP_SCN_00025:
    "Must be numbers, lowercase letters, or accepted symbols (white space, #, -, ., /, :, @, _).",
  APP_SCN_00026:
    "Must be numbers, uppercase letters, or accepted symbols (white space, #, -, ., /, :, @, _).",
  APP_SCN_00027: "Must be half-width katakana characters.",
  APP_SCN_00028: "Must be full-width characters.",
  APP_SCN_00029: "Must be a date in {0} format.",
  APP_SCN_00030: "Must be numbers, lowercase or uppercase letters, or hyphen.",
  APP_SCN_00031: "Must be numbers, lowercase letters, or hyphen.",
  APP_SCN_00032: "Must be numbers, uppercase letters, or hyphen.",
  APP_SCN_00033: "Are you sure you want to exit without saving?",
  APP_SCN_00034:
    "Comments with no Action selected will be discarded. Do you want to continue?",
  APP_SCN_00035: "No rows are selected.",
  APP_SCN_00036: "Must be distinct values.",
  APP_SCN_00037: "Must exist in Component Master.",
  APP_SCN_00038: "Unable to delete latest IF definition snapshot.",
  APP_SCN_00039: "At least one item is required.",
  APP_SCN_00040: "Must not be duplicated.",
  APP_SCN_00041: "Can not {0} for records with status other than {1}.",
  APP_SCN_00042: "Incorrect type code.",
  APP_SCN_00043:
    "Deployment requests on {0} will be outside of operating time. Do you want to continue anyway?",
  APP_SCN_00044: "Saved successfully.",
  APP_SCN_00045: "Do you want to save your changes?",
  APP_SCN_00046: "Switch IE Maintenance mode?",
  APP_SCN_00047: "Couldn't get project data.",
  APP_SCN_00048: "The requested partner code is already in use.",
  APP_SCN_00049: "Must match the regex {0}.",
  APP_SCN_00050: "Chain type still exists.",
  APP_SCN_00051: "Component project is still in progress.",
  APP_SCN_00052: "IF project is still in progress.",
  APP_SCN_00053: "Select Yes/No for all [Necessity] items.",
  APP_SCN_00054: "Specified protocol does not exist in master.",
  APP_SCN_00055: "Deployment request already exists.",
  APP_SCN_00056:
    "Interface Layout file(s) for File ID(s) {0} do not exist. Please upload layout files before prd deployment request.",
  APP_SCN_00057:
    "Interface Layout file(s) for File ID(s) {0} do not exist. Please upload layout files before prd deployment request.",
  APP_SCN_00058:
    "Cannot create a deployment request because the component is not ready.",
  APP_SCN_00059: "Cannot revert deployment request.",
  APP_SCN_00060:
    "{0} is currently outside of operating time and cannot create a deployment request.",
  APP_SCN_00061: "Cannot get {0}.",
  APP_SCN_00062: "Illegal state transition.",
  APP_SCN_00063: "Cannot set these protocol combinations.",
  APP_SCN_00064:
    "Root component cannot be deleted because related components still exist.",
  APP_SCN_00065: "Cannot change the status of a closed project.",
  APP_SCN_00066:
    'The status cannot be changed from "Requirement Design" to "Complete".',
  APP_SCN_00067:
    "You can set the IFD deployable flag only for projects that are in progress.",
  APP_SCN_00068:
    '"IF Can Deployment" for projects not in progress cannot be changed.',
  APP_SCN_00069:
    "Cannot execute because there is a project in progress with the same component and protocol.",
  APP_SCN_00070:
    "To run your project, you must set a staging and production deployment planning date.",
  APP_SCN_00071:
    "Cannot complete the project because there are tickets that have not been closed.",
  APP_SCN_00072:
    "The staging and production planned deployment dates must be set before the earliest planned deployment date of the associated IF project.",
  APP_SCN_00073:
    "Cannot set IF Can Deploy since the component has never been deployed.",
  APP_SCN_00074: "Event Type is divided for the event group.",
  APP_SCN_00075:
    "{0} team stakeholders are not registered in the component project.",
  APP_SCN_00076: "Required data {0} is not in {1} master.",
  APP_SCN_00077: "Combination of team and role is invalid.",
  APP_SCN_00078: "Combination of user and selected role is invalid.",
  APP_SCN_00079: "There must be only one user with primary.",
  APP_SCN_00080: "Select a User.",
  APP_SCN_00081: "{0} the project.",
  APP_SCN_00082: "Requests a quote from PIC of IF Requirement.",
  APP_SCN_00083: "Requests DIP Manager to confirm the quotation results.",
  APP_SCN_00084:
    "Reply to project manager with the result of the quotation. If you reject, please write the reason for rejection in the comment field below.",
  APP_SCN_00085: "Request DIP Manager to approve the project plan.",
  APP_SCN_00086:
    "Reply to Project Owner with the result of the project plan. If you reject, please write the reason for rejection in the comment field below.",
  APP_SCN_00087: "{0} IF requirements.",
  APP_SCN_00088:
    "Withdraw the project plan approval request. Please enter the reason in the comment field below.",
  APP_SCN_00089:
    "Returns the project plan to the status of Estimation In Progress. Running projects will be pended.",
  APP_SCN_00090:
    "This project has been registered. IE team will contact you for consultation.",
  APP_SCN_00091:
    "The registered PIC of IF Requirement have been notified of instructions to define requirements and estimate the cost.",
  APP_SCN_00092:
    "A request for confirmation of the contents of the quotation has been sent to the DIP Manager. DIP Manager will reply to Project Owner with the results of the quotation.",
  APP_SCN_00093:
    "The quotation result has been replied to Project Owner. Project Owner will starts budget acquisition.",
  APP_SCN_00094: "Re-Estimation has been requested to PIC of IF Requirement.",
  APP_SCN_00095:
    "Requesting approval of the project plan from the DIP Manager. Once approved by the DIP Manager, the project plan will be complete.",
  APP_SCN_00096:
    "The project plan is now complete. A notification has been sent to the PIC of IF Requirement, with instructions to register the details of the IF requirements.",
  APP_SCN_00097: "Request for approval of project plan has been rejected.",
  APP_SCN_00098:
    "IF requirements definition have been determined and stakeholders notified.",
  APP_SCN_00099: "Project has been started.",
  APP_SCN_00100: "Project has been closed.",
  APP_SCN_00101: "Request for approval of project plan has been withdrawn.",
  APP_SCN_00102:
    "The status of the project plan has been changed back to Estimation In Progress.",
  APP_SCN_00103:
    "IF requirement definition has been determined again, and the pending project has been resumed.",
  APP_SCN_00104: "This project has been declared cancelled.",
  APP_SCN_00105: "Status has changed. You can now edit the IF requirement.",
  APP_SCN_00106: "End date must be equal or later than Start date.",
  APP_SCN_00107:
    'No new roles or teams can be added after the "Project In Progress" status.',
  APP_SCN_00108:
    'Primary user cannot be deleted after the "Project In Progress" status.',
  APP_SCN_00109:
    "Cannot revert the status to waiting for project execution because there is a ticket in progress.",
  APP_SCN_00110: "{0} already exists.",
  APP_SCN_00111:
    "{0} cannot be deleted because it is being used by a running Project.",
  APP_SCN_00112:
    "{0} cannot be deleted because it is being used in a production environment.",
  APP_SCN_00113:
    "When {0} is enabled, protocol {1} for {2} cannot be selected.",
  APP_SCN_00114:
    "When Use Assumed Role is enalbled, the outbound protocol object storage can only be selected in AWS.",
  APP_SCN_00115: "IF start method {0} cannot be selected for protocol {1}.",
  APP_SCN_00116:
    "When the EDI Usage is enabled, IF start method {0} cannot be selected for protocol object storage.",
  APP_SCN_00117: "{0} is required item.",
  APP_SCN_00118: "The status transition is unsupported.",
  APP_SCN_00119:
    "Do you want to issue a File ID? Once issued, you will need to upload the layout file.",
  APP_SCN_00120: "Must be Y or N.",
  APP_SCN_00121: "The required component project is not linked.",
  APP_SCN_00122:
    "The same conversion rule already exist. Environment ID From: {0}, Environment ID To: {1}, Component ID: {2}, Boundary ID: {3}, Interface Item Group Number: {4}, Interface Item Number: {5} IF Definition Conversion Rule Type Code: {6}",
  APP_SCN_00123:
    "The same conversion rule already exist. Environment ID From: {0}, Environment ID To: {1},Component Attribute Number: {2}, Component ID: {3}",
  APP_SCN_00124: "Cannot create duplicate environment copy conversion rules.",
  APP_SCN_00125: "{0} is not found.",
  APP_SCN_00126:
    "Retrieves the value of the item associated with the specified Key from the DB. This will overwrite the edited value.",
  APP_SCN_00127: 'Rows marked "Cancel" will be deleted.',
  APP_SCN_00128: "Some lines will be cancel or purge status.",
  APP_SCN_00129: "Must not be set.",
  APP_SCN_00130:
    "Cannot be canceled environment copy deployment requests with a status other than deployment pending.",
  APP_SCN_00131:
    "Definition set versions of environments {0} and {1} are incompatible.",
  APP_SCN_00132:
    "Environment copy deployment to environment {0} is in progress.",
  APP_SCN_00133: "Save the review of the selected deployment request?",
  APP_SCN_00134: "Withdraw the selected deployment request?",
  APP_SCN_00135: "Retry the selected deployment request?",
  APP_SCN_00136: "Revert the selected deployment request?",
  APP_SCN_00137: "Required stakeholder is not registered.",
  APP_SCN_00138:
    "Data Kind Id must be (numbers, lowercase letters or uppercase letters) and 7 digit,  must not start from letter, and must not be only numbers.",
  APP_SCN_00139: "Failed to display per-line error messages (invalid index).",
  APP_SCN_00140:
    "A record with the same Data Kind Id must have the Base File flag set to Yes.",
  APP_SCN_00141: "{0} does not exist. ",
  APP_SCN_00142:
    "Data Kind ID and Component ID are required to issue a File ID.",
  APP_SCN_00143:
    'Cannot be withdrawn because deployment status is other than "Waiting Request Plan" or "Deployed".',
  APP_SCN_00144:
    "Cannot be changed because the required tasks selection has been completed.",
  APP_SCN_00145:
    "There is no IF with {0} waiting to deploy as an attribute value ",
  APP_SCN_00146: "There are no changes to the data.",
  APP_SCN_00147: "Cannot be deleted because the component has valid {0}.",
  APP_SCN_00148:
    "Partner code must be 8 half-width digits, and first digit must be 1 or 2.",
  APP_SCN_00149:
    "Cannot create component project with a specified protocol due to lack of IE Maintenance authority.",
  APP_SCN_00150:
    "Cannot be determined again because deployment is in progress.",
  APP_SCN_00151:
    "Cannot change Cancel Requirement Type because the IF requirement has already been deployed in production environment.",
  APP_SCN_00152:
    "Cannot set the deployment datetime to a datetime in the past.",
  APP_SCN_00153:
    "Cannot create deployment request in environments other than production and staging.",
  APP_SCN_00154: "Duplicated with the following projects. {0}",
  APP_SCN_00155: "Data Kind Id {0} has already been broadcast.",
  APP_SCN_00156:
    "There is a problem with the IF requirement. Check the IF requirement list.",
  APP_SCN_00157:
    "Duplicate Deployed IDs detected. Check the IF requirement list.",
  APP_SCN_00158:
    "Staging deployment planned date for project execution is required.",
  APP_SCN_00159: "Are you sure you want to {0} the deployment request?",
  APP_SCN_00160:
    "Cannot deploy component name because there is no EDH protocol linked to the component.",
  APP_SCN_00161: "Component name waiting to be changed must be set.",
  APP_SCN_00162:
    "A project started by IE maintenance cannot be reverted to the Component Project Requirements Design state.",
  APP_SCN_00163:
    "The attribute cannot be edited because it is duplicated in another project.",
  APP_SCN_00164:
    "A ticket with an unclear deployment status has been detected. Check the interface list.",
  APP_SCN_00165: "There is one or more rows that failed to save.",
  APP_SCN_00166:
    "Rows with duplicate issues are selected.These cannot be deployed.",
  APP_SCN_00167: "File size is too large. Must be {0} MB or below.",
  APP_SCN_00168:
    "Are you sure you want to discard the deployment request specified in the checkbox?",
  APP_SCN_00169: "Are you sure you want to  {0} the {1}?",
  APP_SCN_00170: "Are you sure you want to permanently delete this data?",
  APP_SCN_00171:
    "Are you sure you want to cancel the request waiting to be copied?",
  APP_SCN_00172: "A user with the same team code and role code already exists.",
  APP_SCN_00173:
    "The user who created the deployment request cannot approve or reject it.",
  APP_SCN_00174: "IE Maintenance IF attributes cannot be re-entered.",
  APP_SCN_00175: "IE Maintenance IF attributes cannot be dimissed.",
  APP_SCN_00176:
    "Showing {0} of {1} matches for your search. Please narrow it down further.",
  APP_SCN_00177:
    "Requested an IF design review. Please wait until the review is complete.",
  APP_SCN_00178: "Review completed.",
  APP_SCN_00179:
    "Important!\nIt will register a new file layout and number a new File ID.\nPlease confirm existing file layouts, and enter OK button only if you can't use existing one.\nOnce you enter it, please put a file layout document on SharePoint below.\n　\nFile layout document naming rule :  Interface_Layout_Definition_{0}.xlsx\n　\nSharePoint location : \n<G2M>(ext) [Ariake2.0]002_IF_Platform > 50.VariousLists > InterfaceLayoutDocuments > {1} > {2} ",
  APP_SCN_00180:
    "Discard unsaved changes on all rows. Retrieves the value of the item associated with the specified Key from the DB. This will overwrite the edited value. Do you want to continue?",
  APP_SCN_00181:
    "The request contains multiple records for the same user, team code and role code.",
  APP_SCN_00182: "Input data is valid.",
  APP_SCN_00183:
    "Cancel Requirement Type cannot be saved as Cancel or Purge because the IF Requirement has never been saved.",
  APP_SCN_00184:
    "There are IF definitions where multiple Inbound IDs are tied to a single Interdomain ID, which cannot be modified in a normal project.",
  APP_SCN_00185: "You cannot edit because {0} has already been changed.",
  APP_SCN_00186:
    "Cannot bulk paste this item, because this change would modify other cells.",
  APP_SCN_00187:
    "The project cannot be completed because the {0} IF can deploy flag is No.",
  APP_SCN_00188: "Must be numbers, uppercase letters, or accepted symbols (_).",
  APP_SCN_00189:
    "Cannot update the status of projects that have the same component ID and protocol simultaneously from 'Component Project Requirement Design' to 'Project In Progress'.",
  APP_SCN_00190:
    "Cannot create a deployment request for an undeployed DataKindName. Please uncheck the row with Deployed In EDH set to No.",
  APP_SCN_00191:
    "Cannot apply changes DataKindName used in a deployed IF. Please uncheck the row with Deployed In EDH set to Yes.",
  APP_SCN_00192: "Interface Requirement Type is incorrect.{0}",
  APP_SCN_00193:
    'If the Base File Flag is "Yes", the Fork Reason must be "Origin".',
  APP_SCN_00194:
    'If the Base File Flag is "No", the Fork Reason must be something other than "Origin".',
  APP_SCN_00195:
    "Cannot set a File Id when the Data Kind ID does not contain any characters.",
  APP_SCN_00196:
    'The file ID must consist of seven alphanumeric characters, followed by a "-" and three numbers or four alphanumeric characters, followed by a "-" and three numbers.',
  APP_SCN_00197: "The file ID already exists.",
  APP_SCN_00198: "Cannot set the same File Id.",
  APP_SCN_00199: "If metaOnlyFlag is Yes, {0} cannot be updated.",
  APP_SCN_00200: "If metaOnlyFlag is Yes, new IF routes cannot be added.",
  APP_SCN_00201: "metaOnlyFlag cannot be entered with requirement {0}.",
  APP_SCN_00202:
    "If metaOnlyFlag is Yes, the only allowed requirement types are Update/Update, Update/NoChange, and NoChange/Update.",
  APP_SCN_00203:
    "Interface Layout file for File ID {0} do not exist. Please upload layout files before prd deployment request.",
  APP_SCN_00204: "Only one primary role allowed.",
  APP_SCN_00205:
    "Coverage Code for roles DIP Manager and IE Maintenance must be 'JEDI'.",
  APP_SCN_00206:
    "Coverage Code 'JEDI' is only allowed for roles DIP Manager and IE Maintenance.",
  APP_SCN_00207: "Coverage Code must be 'JEDI' or DIP.",
  APP_SCN_00208:
    "A record with the following key values already exists, or the key is duplicated: {0}.",
  APP_SCN_00210: "There is no data to output.",
};
